/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './room.reducer';

export const RoomDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const roomEntity = useAppSelector(state => state.room.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="roomDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.room.detail.title">Room</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.room.id">Id</Translate>
            </span>
          </dt>
          <dd>{roomEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.room.name">Name</Translate>
            </span>
          </dt>
          <dd>{roomEntity.name}</dd>
          <dt>
            <span id="roomNumber">
              <Translate contentKey="tinyMedicRestApp.room.roomNumber">Room Number</Translate>
            </span>
          </dt>
          <dd>{roomEntity.roomNumber}</dd>
          <dt>
            <span id="tempClosed">
              <Translate contentKey="tinyMedicRestApp.room.tempClosed">Temp Closed</Translate>
            </span>
          </dt>
          <dd>{roomEntity.tempClosed ? 'true' : 'false'}</dd>
          <dt>
            <span id="dateClosed">
              <Translate contentKey="tinyMedicRestApp.room.dateClosed">Date Closed</Translate>
            </span>
          </dt>
          <dd>{roomEntity.dateClosed}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.room.description">Description</Translate>
            </span>
          </dt>
          <dd>{roomEntity.description}</dd>
          <dt>
            <span id="bedNoStart">
              <Translate contentKey="tinyMedicRestApp.room.bedNoStart">Bed No Start</Translate>
            </span>
          </dt>
          <dd>{roomEntity.bedNoStart}</dd>
          <dt>
            <span id="bedNoEnd">
              <Translate contentKey="tinyMedicRestApp.room.bedNoEnd">Bed No End</Translate>
            </span>
          </dt>
          <dd>{roomEntity.bedNoEnd}</dd>
          <dt>
            <span id="bedPrefix">
              <Translate contentKey="tinyMedicRestApp.room.bedPrefix">Bed Prefix</Translate>
            </span>
          </dt>
          <dd>{roomEntity.bedPrefix}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.room.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{roomEntity.modifiedBy}</dd>
          <dt>
            <span id="modifiedTime">
              <Translate contentKey="tinyMedicRestApp.room.modifiedTime">Modified Time</Translate>
            </span>
          </dt>
          <dd>{roomEntity.modifiedTime}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.room.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{roomEntity.createdBy}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.room.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{roomEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.room.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{roomEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.room.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{roomEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.room.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{roomEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.room.active">Active</Translate>
            </span>
          </dt>
          <dd>{roomEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="roomType">
              <Translate contentKey="tinyMedicRestApp.room.roomType">Room Type</Translate>
            </span>
          </dt>
          <dd>{roomEntity.roomType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.room.ward">Ward</Translate>
          </dt>
          <dd>{roomEntity.ward ? roomEntity.ward.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/room" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/room/${roomEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RoomDetail;
